import React from 'react';
import Footer from './Footer';

function Terms() {
  return (
    <>
      <section id="emailus">
        <div className="container">
          <div className="row">
            <div className="col col-md-12 text-center">
              <h2 className="text-dark">Terms of Services</h2>
              <hr className="my-4 mx-auto" />
            </div>
          </div>
        </div>
        <div className="container py-2 text-left">
          <div className="row py-1">
            <div className="col">
              <h5>STANDARD TERMS AND CONDITIONS</h5>
              <p>
                These are the standard terms and conditions include but not restricted to Website Design and Development and will apply 
                to all contracts and/or works undertaken by "One.all Company" herein referred to as "Onedotall" for its clients.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>NON-DISCLOSURE</h5>
              <p>
                We, "Onedotall" (and any subcontractors/re-sellers/outsourced party we engage) agree to not to disclose any of your confidential 
                information to any third party at any time. And you are also not allowed to disclose any of our confidential information to any 
                individual/organisation/platform.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>FEES AND DEPOSITS</h5>
              <p>
                A 50% deposit of the total fee payable under our proposal is due immediately upon you instructing us to proceed with the 
                work. The remaining 50% shall become due when the work is completed to your reasonable satisfaction. We reserve the right 
                not to commence any work until the deposit has been paid in full. Non payment of the remaining amount after completion of 
                the work upto a maximum of 72 hours may lead to discontinuation/rollback of work/service and/or legal action.
              </p>
              <p>
                In case of cancellation of your work order within 72 hours, 90% of the advance deposit will be refunded. Otherwise, the 50% 
                deposit of advance paid is NON refundable. If we fail to deliver the work due to any unavoidable circumstances, 
                90% of that advance will be refunded.
              </p>
              <p>
                All prices displayed in the Plans section of this website should be treated for (but not limited to) the end user facing (No Admin Panel/CMS) 
                applications only. We request you to have a detailed discussion before placing any order to avoid any misunderstanding.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>VARIATIONS</h5>
              <p>
                We are pleased to offer you the opportunity to make revisions to the design/content/functionality. However, we have the right 
                to limit the number revisions to a reasonable amount and may charge for additional specification (if any).
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>PROJECT DELAYS AND CLIENT LIABILITY</h5>
              <p>
                Any time frames or estimates that we give are contingent upon your full co-operation. During development there is a certain 
                amount of two-way communication required in order to progress to subsequent phases. It is required that a single point of 
                contact to be appointed from your side and be made available as and when required.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>APPROVAL OF WORK</h5>
              <p>
                On completion of the work you will be notified and have the opportunity to review it. You must acknowledge the same within 
                72 hours of such notification. After that, it will be deemed to have been approved. Once approved, or deemed approved, work
                cannot subsequently be rejected and the contract will be deemed to have been completed and the remaining payment will become due.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>REJECTED WORK</h5>
              <p>
                If you reject any of our work within the 72 hours review period, or not approve subsequent work performed by us to remedy any
                points recorded as being unsatisfactory, and we, acting reasonably, consider that you have been unreasonable in any rejection
                of the work, we can elect to treat this contract as at an end and take measures to recover payment for the completed work.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>PAYMENT</h5>
              <p>
                Upon completion of the work, and once approved, or deemed approved, you are required to make the balance payment within 72 hours.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>SUPPLY OF MATERIALS (CONTENT)</h5>
              <p>
                You must supply all materials and/or information required by us to complete the work in accordance with any agreed 
                specification. For any delay in supplying such materials to us which leads to a delay in the completion of work, 
                we have the right to extend any previously agreed deadlines by a reasonable amount. If we come to know about 
                violation of The Copyright (Amendment) Act, 2012 by any such contents provided; we may remove the content from 
                the website/webapp without any prior information.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>INTELLECTUAL PROPERTY RIGHTS</h5>
              <p>
                You must obtain all necessary permissions and authorities in respect of the use of all kinds of electronic/digital 
                content, or any other material that you request us to include/serve in your website or web applications.
              </p>
              <p>
                By placing an work order, you indemnify us and hold us harmless in regard to any claims or legal actions related 
                to the content of your website.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>LICENSING</h5>
              <p>
                Once you have paid us in full for our work we will grant to you a license to use the product and/or its related contents
                until subscription (if any) or the expiry of the term.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>CONSEQUENTIAL LOSS</h5>
              <p>
                We shall not be liable for any loss or damage which you may suffer which is in any way attributable to any delay 
                in performance or completion of our contract, however that delay arises.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>ADDITIONAL EXPENSES</h5>
              <p>
                You agree to reimburse us for any requested expenses which do not form part of our proposal including but not limited 
                to the purchase/subscription of templates, third party package/library/software, photographs or any other kind of content.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>CROSS BROWSER/PLATFORM COMPATIBILITY</h5>
              <p>
                We give our best to ensure that the contents we create are compatible with most of the modern platforms. Any Third party 
                extensions, where used, may not have the same level of support for all platforms. Where appropriate, we will substitute 
                alternative extensions or try to implement other solutions, on a best effort basis, where any incompatibilities are found.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>SEARCH ENGINE</h5>
              <p>
                We do not guarantee any specific position in search engine results for your website. However, we use current best 
                practices for search engine optimisation.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>BUSINESS &amp; E-COMMERCE POLICY</h5>
              <p>
                You are solely responsible for complying with all relevant laws relating to any business, e-commerce, and to the full 
                extent permitted by law will hold harmless, protect, defend and indemnify Onedotall and its subcontractors from any 
                claim, penalty, tax, tariff loss or damage arising from your or your clients’ use of that business.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>BACKUPS</h5>
              <p>
                You are responsible for maintaining your own backups with respect to your website/digital content and we will not be held 
                liable for restoring any client data or client websites except to the extent that such data loss arises out of a negligent 
                act or omission by us.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>DOMAIN NAMES AND WEB HOSTING</h5>
              <p>
                We do not provide Domain Name and Web Hosting service of any kind as of now. But we can manage them on your behalf so that 
                you can relax and concentrate on your business.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>SUBCONTRACTING</h5>
              <p>
                We reserve the right to subcontract or outsource any services or parts of work that we have agreed to perform for you as we see fit.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>DISCLAIMER</h5>
              <p>
                To the full extent permitted by law, all terms, conditions, warranties, undertakings, inducements or representations whether
                express, implied, statutory or otherwise (other than the express provisions of these terms and conditions) relating in any
                way to the services we provide to you are excluded. Without limiting the above, to the extent permitted by law, any liability
                of Onedotall under any term, condition, warranty or representation that by law cannot be excluded is, where permitted by law,
                limited at our option to the replacement, re-repair or re-supply of the services or the payment of the cost of the services
                that we were contracted to perform.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>POLICY UPDATES</h5>
              <p>
                Onedotall is permitted to revise these Terms of services/conditions at any time as and when required, the orders taken 
                prior to update of terms of services/conditions will also come under new terms of services/conditions. And by using this website you are 
                expected to review such Terms on a regular basis to ensure you understand all terms and conditions for use of this Website.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  )
}

export default Terms
